export const gestcivil = [
  { value: 'Casada(o)', label: 'Casada(o)' },
  { value: 'Divorciada(o)', label: 'Divorciada(o)' },
  { value: 'Separada(o)', label: 'Separada(o)' },
  { value: 'Solteira(o)', label: 'Solteira(o)' },
  { value: 'Viúva(o)', label: 'Viúva(o)' },
];
